module.exports = __webpack_public_path__ + "static/media/student-services-banner.6b46f055.jpg";